import { format } from 'date-fns';

const getFormattedTime = (timeToFormat) => {
    if (!timeToFormat) return null;

    return format(new Date(timeToFormat), 'hh:mm aa');
};

export default getFormattedTime;
